import Loadable from 'react-loadable';
import LoadingComponent from './';

export default function LoadableHoc(opts) {
  return Loadable({
    loading: LoadingComponent,
    delay: 200,
    timeout: 10000,
    ...opts
  });
};



// WEBPACK FOOTER //
// ./src/components/LoadingComponent/LoadableHoc.js